import { connect } from 'react-redux';

import SignIn from './SignIn';

const mapStateToProps = () => ({});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(SignIn);
